import { Component } from '@angular/core';
import { MaterialPage } from '../../../../components/page/material-page.component';
import { Meta, Title } from '@angular/platform-browser';
import { SidenavService } from 'src/app/_services/sidenav.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BreakpointObserver } from '@angular/cdk/layout';
import { AlertService } from 'src/app/_services';
import { ResellersService } from '../../services/resellers.service';
import { Router } from '@angular/router';

@Component({
  templateUrl: './resellers-page.component.html',
  styleUrls: ['./resellers-page.component.scss']
})
export class ResellersPageComponent extends MaterialPage {

  resellersRequestForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    surname: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    phone: new FormControl('', [Validators.required]),
  });
  
  requestSent: boolean = false;    
    
  constructor(
    private resellersService: ResellersService,
    breakpointObserver: BreakpointObserver,
    titleService: Title,
    meta: Meta,
    private router: Router,
    sidenavService: SidenavService,
    private alertService: AlertService
  ) {
    super(
      breakpointObserver, 
      titleService, 
      meta, 
      sidenavService,
      router,
      $localize `:page title:Reseller`,
      $localize `:page description:Become a Listx Reseller.`,
      true);
  }
  
  async sendRequest() {
    
    if (this.resellersRequestForm.invalid) {
        console.log("Form invalid");
        return;
    }
    
    try {
      await this.resellersService.createResellersRequest({
          name: this.resellersRequestForm.controls["name"].value!,
          surname: this.resellersRequestForm.controls["surname"].value!,
          email: this.resellersRequestForm.controls["email"].value!,
          phone: this.resellersRequestForm.controls["phone"].value!
      });
    } catch {
      this.alertService.showError($localize  `Something went wrong`);
      return;
    }

    this.alertService.showSuccess($localize `Request submitted`);
    this.requestSent = true;
    
    this.router.navigate(['/']);
  }
}